import { IBaseStore } from '@/store/types'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import Api from '../../api'
import { IHmo, IHmoDTO } from '@zunta/configurations'

export interface IHmoState {
    hmos: IHmo[];
    count: number;
}

export interface IHmoStore extends IBaseStore {
    state: IHmoState;
}

@Module({
    name: 'hmo',
    namespaced: true
})
export class HmoModule extends VuexModule {
    hmos: IHmo[] = []
    count: number = 0

    @Mutation
    SET_HMOS (hmos: IHmo[]) {
        this.hmos = hmos
    }

    @Mutation
    SET_HMOS_COUNT (count: number) {
        this.count = count
    }

    @Action
    async addHmo (hmo: IHmoDTO): Promise<'OK'> {
        return Api.hmo.addHmo(hmo)
    }

    @Action
    async getHmoList (filters: any): Promise<void> {
        const { count, hmos } = await Api.hmo.getHmoList(filters)
        this.SET_HMOS(hmos)
        this.SET_HMOS_COUNT(count)
    }

    @Action
    async editHmo (hmo: IHmoDTO): Promise<'OK'> {
        return Api.hmo.editHmo(hmo)
    }

    @Action
    async deleteHmo (id: number): Promise<'OK'> {
        return Api.hmo.deleteHMO(id)
    }
}
